import {ValueObject} from '@s-ui/domain'

export class ContactConfiguratorSellerResponseValueObject extends ValueObject {
  #contactRequestId
  #status

  constructor({contactRequestId, status}) {
    super()
    this.#contactRequestId = contactRequestId
    this.#status = status
  }

  static createFromApi({contactRequestId, status}) {
    return new ContactConfiguratorSellerResponseValueObject({contactRequestId, status})
  }

  get contactRequestId() {
    return this.#contactRequestId
  }

  get status() {
    return this.#status
  }

  get value() {
    return {
      contactRequestId: this.#contactRequestId,
      status: this.#status
    }
  }
}
